import { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Card } from 'antd';
import { Button } from 'antd';

import { sortStrings } from '../../../helpers/filter';

import { EDIT_COMPONENT_TYPE } from '../../../constants/common';
import messages from '../../../constants/messages';

import { bulkUpdateTableConfigurations } from '../../../redux/actions/table-configurations';

import { successToastHandler } from '../../../components/action_notifier';

import AppTable from '../../AppTable';
import { COLUMN_SIZE } from '../../AppTable/constants';
import EditableTableColumnsModal from './EditableTableColumnsModal';

const commonColumnProperties = {
  ellipsis: true,
  sortDirections: ['ascend', 'descend']
};

const AdminTablePreferencesTable = () => {
  const dispatch = useDispatch();

  const { configurations, loading } = useSelector(state => state.tableConfigurations);

  const [editingColumnsTableId, setEditingColumnsTableId] = useState(null);

  const handleInputChange = editedData => {
    dispatch(bulkUpdateTableConfigurations(editedData));
    successToastHandler(messages.UPDATED);
  };

  const columns = [
    {
      ...commonColumnProperties,
      title: 'Table Title',
      dataIndex: 'title',
      editConfig: { type: EDIT_COMPONENT_TYPE.INPUT },
      searchable: true,
      width: COLUMN_SIZE.XXL,
      sorter: (a, b) => sortStrings(a.title, b.title)
    },
    {
      ...commonColumnProperties,
      title: 'Table Sub-title',
      dataIndex: 'description',
      editConfig: { type: EDIT_COMPONENT_TYPE.INPUT },
      searchable: true,
      sorter: (a, b) => sortStrings(a.description, b.description)
    },
    {
      ...commonColumnProperties,
      title: 'Comment',
      dataIndex: 'comment',
      editConfig: { type: EDIT_COMPONENT_TYPE.INPUT },
      searchable: true,
      sorter: (a, b) => sortStrings(a.comment, b.comment)
    },
    {
      ...commonColumnProperties,
      title: 'Actions',
      noPadding: true,
      width: COLUMN_SIZE.LG,
      render: (_, table) => (
        <Button
          style={{ height: 'auto' }}
          type="link"
          onClick={e => {
            e.stopPropagation();
            setEditingColumnsTableId(table.id);
          }}>
          Edit columns
        </Button>
      )
    }
  ];

  const onCloseEditColumnsModal = () => {
    setEditingColumnsTableId(null);
  };

  return (
    <>
      <Card>
        <AppTable
          description="List of tables"
          headerClass="pb-2"
          title="Tables"
          baseColumns={columns}
          dataSource={configurations}
          loading={loading}
          rowsSelectable={false}
          searchable={false}
          settings={false}
          updateTableData={handleInputChange}
        />
      </Card>
      <EditableTableColumnsModal tableId={editingColumnsTableId} onClose={onCloseEditColumnsModal} />
    </>
  );
};

export default memo(AdminTablePreferencesTable);
